import { useState, useEffect } from 'react';
import { Avatar, Box, Chip, Typography } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import ErrorHandler from '@Root/ErrorHandler';
import OrganizationCardService from '@Helpers/URLHelpers/WeboutService/OrganizationCardService';
import moment from 'moment';
import '@Partials/_ComStyles.scss';
import '@Partials/_SimpleStyles.scss';
import '@Partials/_OverrideStyles.scss';
import './NameCardRow.scss';

export default function NameCardRow(props) {
  const [organizationCard, setOrganizationCard] = useState();
  const organizationCardService = new OrganizationCardService();
  const errorHandler = new ErrorHandler();
  const className = 'nameCardRow';
  const isSelected = props.nameCard?.id === props.selectedNameCard?.id;

  useEffect(() => {
    renderData();
  }, [props]);

  const renderData = async () => {
    try {
      if (!!props.nameCard.organization && props.nameCard.organization !== 0) {
        let organizationCardObj = await organizationCardService.getById(props.nameCard.organization);
        organizationCardObj = JSON.parse(organizationCardObj.body);
        setOrganizationCard(organizationCardObj);
      } else {
        setOrganizationCard(null);
      }
    } catch (err) {
      errorHandler.handleError(err);
    }
  };

  const getInitials = (name) => {
    if (!name) return 'NC';
    const parts = name.trim().split(' ');
    if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  };

  const formatDate = (ts) => (ts ? moment(ts).format('MMM DD, YYYY') : '');

  return (
    <div
      className={`${className} ${isSelected ? `${className}--selected` : ''}`}
      onClick={() => props.setSelectedNameCard(props.nameCard)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && props.setSelectedNameCard(props.nameCard)}
    >
      <Box className={`${className}__container`}>
        {/* Avatar */}
        <Avatar
          className={`${className}__avatar`}
          src={props.nameCard?.photo}
          alt={props.nameCard?.name}
        >
          {!props.nameCard?.photo && getInitials(props.nameCard?.name)}
        </Avatar>

        {/* Content */}
        <Box className={`${className}__content`}>
          <Box className={`${className}__header`}>
            <Typography variant="subtitle1" className={`${className}__name`}>
              {props.nameCard?.name || 'Unnamed'}
            </Typography>
            {!!props.nameCard?.createTimeStamp && (
              <Typography variant="caption" className={`${className}__date`}>
                {formatDate(props.nameCard.createTimeStamp)}
              </Typography>
            )}
          </Box>

          <Box className={`${className}__details`}>
            {!!props?.nameCard?.designation && (
              <Chip
                size="small"
                icon={<GroupWorkIcon />}
                label={props.nameCard.designation}
                className={`${className}__chip`}
              />
            )}

            {!!organizationCard?.name && (
              <Box className={`${className}__org`}>
                <BusinessIcon className={`${className}__org__icon`} />
                <Typography variant="caption" className={`${className}__org__text`}>
                  {organizationCard.name}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>

        {/* Selection Indicator */}
        {isSelected && <div className={`${className}__indicator`} />}
      </Box>
    </div>
  );
}
